module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/portal/packages/core-app/src/templates/passiveAlertView.html -->\n<div class="hit"></div>\n<div class="container-fluid '+
((__t=( className ))==null?'':__t)+
'">\n	<div class="container">\n		<p>'+
((__t=( message ))==null?'':_.escape(__t))+
'</p>\n		<div class="close" data-nx-control="close">\n			'+
((__t=( icons.faTimes ))==null?'':__t)+
'\n		</div>\n	</div>\n</div>\n';
}
return __p;
};
